<template>
	<c-dialog ref="dialog" :title="dialogTitle" width="800" height="550">
        <div v-if="active == 1" class="tip-div">
            <div class="import-steps">
                <h5>步奏一、下载导入模板</h5>
                <p>·请按照模板中的列头批注说明填写完善表格中的内容。点击这里<a style="color: blue;" @click="downloadTemplate()">下载模板</a></p>
                <p>·下载模板后，请按<a style="color: blue;" @click="showNoticeMsg()">导入说明</a>照填写完善表格中的内容。</p>
                <p>·当上传的表格有多个Sheet时，仅解析第一个Sheet的数据。</p>
            </div>
        </div>
        <div v-if="active == 1" class="tip-div">
            <div class="import-steps">
                <h5>步奏二、上传完善好的表格</h5>
                <p>·仅支持上传Excel文件(Excel2007及以上版本)，导入文件最大不超过5MB，数据不超过1000行。</p>
                <c-button hollow @click="uploadHandle"><i class="tf sf-file-xls"></i>上传导入文件</c-button>
            </div>
        </div>
        <div v-if="active == 2" class="tip-div">
            <div class="import-steps">
                <p>· 带<b style="margin: 0 5px; color: #f00;">*</b>的数据必须填写（选择对应的Excel表头）。</p>
            </div>
        </div>
        <div v-if="active == 2">
            <c-table ref="table" :data="matchColumnList" height="320" border :paging="false">
                <c-table-column :label="'系统字段 (共 '+sysColumnTotal+' 列)'" width="250" fixed="left">
                    <template #default="{data}">
                        <div class="flex-left">
                            {{data.system_column_name}}
                            <b v-if="data.required==1" style="margin-left: 5px; font-size: 14px; color: #f00;">*</b>
                        </div>
                    </template>
                </c-table-column>
                <c-table-column :label="'Excel表头 (共 '+excelColumnTotal+' 列)'" width="300">
                    <template #default="{data}">
                        <c-select name="excel_column_name" :options="excelColumnOptions" v-model="data.excel_column_name"></c-select>
                    </template>
                </c-table-column>
            </c-table>
        </div>

        <div v-if="active == 3" class="tip-div">
            <div class="import-fruit flex-column flex-center">
                <h1>导入结果</h1>
                <p>
                    共导入
                    {{this.importResult.total_count}}条数据；
                    成功：<b style="color: green">{{this.importResult.success_count}}条</b>；
                    失败：<b style="color: red">
                        {{this.importResult.fail_count}}条
                    </b>
                    <a v-if="this.importResult.fail_count > 0 && this.importResult.error_file_url" style="color:blue; margin-left: 20px;" @click="downloadErrorFile()">下载错误报告</a>
                </p>
            </div>
        </div>
        <template #button>
            <c-button v-if="active == 2" size="form" color="main" hollow @click="previousStep()">上一步</c-button>
            <c-button v-if="active == 2 && excel_file" size="form" color="main" @click="submit()">确定导入</c-button>
            <c-button v-if="active == 3" size="form" color="main"hollow @click="previousStep()">继续导入</c-button>
            <c-button v-if="active == 3" size="form" color="main"@click="finish()">导入完成</c-button>
        </template>

        <!--提示信息-->
        <c-dialog ref="noticeDialog" width="700" title="导入说明" button-name="我知道了" :cancel-button="false">
            <div v-html="noticeMsg" class="import-explain"></div>
        </c-dialog>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		name: 'excelImport',
		props: {
			workType: [String, Number]
		},
		watch: {
		},
		data() {
			return {
                title:'导入数据',
				active:1,
				import_type:1,
				excel_file:'',              //上传文件路径
				matchColumnList:[],
				sysColumnTotal:0,           //系统业务总列数
				excelColumnTotal:0,         //导入Excel总列表
				excelColumnOptions:[],       //导入Excel表头信息（去重）
				importResult:null,
				errorFlag:false,
			}
		},

		computed: {
			// 获取dictName选项数据
            ...mapState(['userInfo', 'systemConfig']),

			noticeMsg() {

				var resultMsg = {
                    901: [
                        '<p>1、订单编号：<span style="color:red">【必填】</span>，最多输入 50 个字符；<strong>必须是系统中存在的单号</strong>；</p>',
                        '<p>2、SKU编码；<span style="color:red">【必填】</span>，最多输入 50 个字符，填写了则表示仅发该SKU的商品，未填写则表示整个订单全部发货；<strong>必须是系统中存在的SKU编码（区分英文大小写）</strong>；</p>',
                        '<p>4、发货数量；<span style="color:red">【必填】</span>，必须输入1~9999之间的正整数；<strong>导入的所有同一个订单中的SKU数量总和不能超过可发数量，否则所有SKU记录发货失败</strong>；</p>',
                        '<p>5、物流公司；<span style="color:red">【必填】</span>，填写物流公司名称；<strong>该名称必须在【商品->运费设置->发货物流】功能中已配置</strong>；</p>',
                        '<p>6、运单号；<span style="color:red">【选填】</span>，最多输入 50 个字符,当发货物流等于【自提】或【公司配置】时，运单号允许为空，其他情况必须填写。<strong>一个运单号只允许使用一次</strong>；</p>',
                        '<p>•导入发货数据时，请保证数据表中的<span style="color:red">【订单号】+【SKU编码】+【物流公司】+【运单号】</span>唯一</p>',
                    ].join('')
				}[this.workType];
                var commonMsg = [
                    '<p><span style="color:darkgray">• 时间类型字段：支持格式YYYY-MM-DD HH:mm和YYYY/MM/DD HH:mm。</span></p>',
                    '<p><span style="color:darkgray">• 数字类型字段：整数位请勿超过 10 位，小数位请勿超过 6 位。</span></p>'
                ].join('')
                return resultMsg + commonMsg;
			},

			dialogTitle() {
				var workTypeName = {
                    901: '【批量发货】'
				}[this.workType];
                workTypeName = '导入'+workTypeName+'数据';
                return workTypeName;
			}
		},

		methods: {
			/************打开新增、编辑弹窗，数据初始化**************/
			open() {
				this.import_type = 1;//仅新增
				this.active = 1;//恢复初始值
				this.excel_file = '';
				this.errorFlag = false;
                this.$refs.dialog.open();
			},

			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/*****************下载导出模板**********************/
			downloadTemplate(){
				this.request({
					url: '/import/url',
					data:{
						work_type:this.workType
					},
					success: data => {
						this.download({
							fileName: data.filename,
							url: data.url,
							loading: {
								message: '数据文件生成中...'
							}
						});
					}
				});
			},

			/*****************展示导入说明数据**********************/
			showNoticeMsg(){
				this.$refs.noticeDialog.open();
			},

			/*****************上传文件**********************/
			uploadHandle() {
                this.commonUploadFile({
                    type:'xls,xlsx',
                    multiple: false,
                    success: ([data]) => {
                        console.log(data)
                        this.excel_file = data.path||'';
                        if (!this.excel_file){
                            this.$message({
                                text: '请上传文件',  // 提示内容,
                                type: 'warn'
                            });
                            return;
                        }
                        var suffix = this.excel_file.substring(this.excel_file.lastIndexOf('.')+1).toLowerCase();
                        if (suffix!='xls' && suffix!='xlsx'){
                            this.$message({
                                text: '请上传Excel文件',  // 提示内容,
                                type: 'warn'
                            });
                            return;
                        }
                        //执行分析
                        this.analysisUploadFile();
                    }
                });
			},

			/*****************解析上传成功的Excel文件**********************/
			analysisUploadFile() {
				this.request({
					url: '/import/analysis/excel/head',
					data: {
						work_type: this.workType,
						view_id: this.view_id,
						url: this.excel_file
					},
					loading: {
						message: '文件上传解析中...'
					},
					success: data => {
						this.errorFlag = false;
						this.matchColumnList = data.matchColumnList || [];
						this.matchColumnList.map(field => {
							if (field.is_custom == 0 && field.field_type == 4) {
								if (field.config_json.dict_config) {
									var optionsList = dictList[field.config_json.dict_config.dictName].map(item => {
										var obj = {};
										obj.value = item.name;
										obj.name = item.name;
										return obj;
									});
									this.$set(field, 'options',optionsList);
								} else if (field.config_json.dict_config.dictType == 'DBDIC') {
									this.request({
										url:'/system/options',
										data: {
											options_code:field.config_json.dict_config.dictName
										},
										success:data => {
											var optionsList = data.map(item => {
												var obj = {};
												var name = item.name;
												//客户
												if ('CUSTOMER'== field.config_json.dict_config.dictName){
													name = item.data.customer_name;
												//不良品项
												}else if ('DICDEFECTS'== field.config_json.dict_config.dictName){
													name = item.data.defects_name;
												//工序
												}else if ('DICPROCESS'== field.config_json.dict_config.dictName){
													name = item.data.process_name;
												//工艺路线
												}else if ('PROCESSROUTE'== field.config_json.dict_config.dictName){
													name = item.data.route_name;
												//供应商
												}else if ('SUPPLIER'== field.config_json.dict_config.dictName){
													name = item.data.supplier_name;
												//仓库
												}else if ('WAREHOUSE'== field.config_json.dict_config.dictName){
													name = item.data.warehouse_name;
												}
												
												obj.value = name;
												obj.name = name;
												return obj;
											});
											this.$set(field, 'options', optionsList);
										}
									});
								}
							}
							field.column_default_value = '';
						});
						this.sysColumnTotal = data.sysColumnTotal || 0;
						this.excelColumnTotal = data.excelColumnTotal || 0;
						this.excelColumnOptions = data.excelColumnOptions || [];
						setTimeout(() => {
							this.active = 2;//上传文件完成，跳转配置表单页面
						}, 500);
					},
					fail: () => {
						this.errorFlag = true;
					}
				});
			},

			//回退至上一步
			previousStep(){
				this.active = 1;
			},

			//完成
			finish(){
				this.$refs.dialog.close();
			},
			/************下载错误文件************/
			//
			submit(){
				//判断【必填】项是否已填写
				var submitFlag = true;
				this.matchColumnList.forEach(item => {
					if (item.required==1
						&& (!item.excel_column_name || item.excel_column_name == '')
						&& (!item.column_default_value || item.column_default_value == '')
					){
						submitFlag = false;
						this.$message({
                            text: '请完善所有带星号的【必填】数据列',  // 提示内容,
							type: 'warn'
						});
						return;
					}
				});
				if (submitFlag){
					this.request({
						url: '/import/analysis/excel/data',
						data: {
							work_type:this.workType,
							view_id:this.view_id,
							url: this.excel_file,
							match_column_list: this.matchColumnList,
							import_type: this.import_type,
							warehouse_id: this.warehouse_id,
							order_classify: this.order_classify
						},
						loading: {
							message: '导入数据处理中...'
						},
						success: data => {
							this.errorFlag = false;
							this.importResult = data;
							setTimeout(() => {
								this.active = 3;//恢复初始值
								//执行回调方法
								this.$emit('resolve');
							}, 500);
						},
						fail: () => {
							this.errorFlag = true;
						}
					});
				}
			},

			/************下载错误文件************/
			downloadErrorFile() {
				this.download({
					fileName: this.importResult.error_file_name,
					url: this.importResult.error_file_url,
					loading: {
						message: '数据文件生成中...'
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
    .tip-div {
        /* 四个值：上 | 右 | 下 | 左 */
        padding: 20px 20px 20px 20px;
    }

	.import-steps {
		padding: 10px 20px;
		background-color: #F8F8F8;

		h5 {
			line-height: 36px;
			font-size: 15px;
		}

		p {
			padding: 4px 0;
			line-height: 20px;
			color: #666;
		}
	}

	.import-explain {
		padding: 20px;

		>>> p {
			padding: 4px 0;
			line-height: 20px;
		}
	}

	.import-fruit {
		height: 200px;
		background-color: #F8F8F8;

		h1 {
			margin-bottom: 30px;
			font-size: 26px;
		}
	}
</style>